<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-if="modulo === 'booking'">
                <h2 class="search-title">{{ searchboxheadlineflights[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-plane-right takeoff-effect"></i>
            </div>
            <div class="title-container" v-if="modulo === 'services'" v-bind:style="{ background: '#0082c8' }">
                <h2 class="search-title">{{ searchboxheadlineservices[getCurrentLocale] }}</h2>
                <!-- <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p> -->
                <i class="soap-icon-plane-right takeoff-effect"></i>
            </div>



            <div class="search-content">
                <!-- >>> FlightType -->
                <div class="row choose-travel">
                    <div class="col-xs-6">
                        <label class="radio radio-inline" v-bind:class="{ radiosrvcs: modulo === 'services' }">
                            <input type="radio" name="choose-travel" value="1" v-on:change="outwardonly = false"
                                checked>{{ outwardandreturnflight[getCurrentLocale] }}
                        </label>
                    </div>
                    <div class="col-xs-6">
                        <label class="radio radio-inline" v-bind:class="{ radiosrvcs: modulo === 'services' }">
                            <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = true">{{
                            outwardonlyflight[getCurrentLocale] }}
                        </label>
                    </div>
                </div>


                <hr>


                <!-- >>> Departure/Destination -->
                <h5 class="title">{{ where[getCurrentLocale] }}</h5>
                <div class="row" v-if="modulo === 'booking'">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparture[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode" ref="depArprtCode" :clearable="false"
                            :disabled="!departuresLoaded" v-model="depArprtCode" :options="airportsOrigins" label="l"
                            key="i" :value="i" class="style-chooser"
                            :placeholder="this.departureairport[this.getCurrentLocale]"
                            @input="call_listAirportsDestinations"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestination[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode" ref="desArprtCode" :clearable="false"
                            :disabled="!destinationsLoaded" v-model="desArprtCode" :options="airportsDestinations"
                            label="l" key="i" :value="i" class="style-chooser"
                            :placeholder="this.destinationairport[this.getCurrentLocale]"></v-select>
                    </div>
                </div>

                <div class="row" v-if="modulo === 'services'">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparture[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode" ref="depArprtCode" :clearable="false"
                            :disabled="!departuresLoaded" v-model="depArprtCode" :options="airportsOrigins" label="l"
                            key="i" :value="i" class="style-chooser-srvcs"
                            :placeholder="this.departureairport[this.getCurrentLocale]"
                            @input="call_listAirportsDestinations"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestination[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode" ref="desArprtCode" :clearable="false"
                            :disabled="!destinationsLoaded" v-model="desArprtCode" :options="airportsDestinations"
                            label="l" key="i" :value="i" class="style-chooser-srvcs"
                            :placeholder="this.destinationairport[this.getCurrentLocale]"></v-select>
                    </div>
                </div>


                <hr>


                <!-- >>> Date Dep/Date Des -->
                <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-6">
                        <label>{{ departuredate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair" v-if="modulo === 'booking'">
                            <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy"
                                :value="today">
                        </div>
                        <div class="datepicker-wrap sundairsrvcs" v-if="modulo === 'services'">
                            <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy"
                                :value="today">
                        </div>
                    </div>

                    <div class="col-xs-6">
                        <label v-show="outwardonly === false">{{ returndate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair" v-show="outwardonly === false" v-if="modulo === 'booking'">
                            <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy"
                                :value="tommorow">
                        </div>
                        <div class="datepicker-wrap sundairsrvcs" v-show="outwardonly === false"
                            v-if="modulo === 'services'">
                            <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy"
                                :value="tommorow">
                        </div>
                    </div>
                </div>


                <hr>


                <!-- >>> Who? -->
                <h5 class="title">{{ who[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-4 col-md-4">
                        <label>{{ adult[getCurrentLocale] }}<br>{{ adultyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noADT">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ child[getCurrentLocale] }}<br>{{ childyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noCHD">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ infant[getCurrentLocale] }}<br>{{ infantyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noINF">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>


                <hr>


                <!-- >>> Submit -->
                <!-- <button type="submit" class="full-width btn-medium sundair">{{ findflights[getCurrentLocale] }}</button> -->
                <button type="submit" class="btn-medium icon-check uppercase full-width"
                    v-if="modulo === 'booking' && depArprtCode !== '' && desArprtCode !== ''">{{
                    findflights[getCurrentLocale] }}</button>
                <a class="button btn-medium uppercase full-width silver"
                    v-if="modulo === 'booking' && (depArprtCode === '' || desArprtCode === '')">{{
                    findflights[getCurrentLocale] }} </a>


                <button type="submit" class="btn-medium icon-check-srvcs uppercase full-width"
                    v-if="modulo === 'services' && depArprtCode !== '' && desArprtCode !== ''"
                    v-bind:style="{ background: '#0082c8' }">{{ findflights[getCurrentLocale] }}</button>
                <a class="button btn-medium uppercase full-width silver"
                    v-if="modulo === 'services' && (depArprtCode === '' || desArprtCode === '')">{{
                    findflights[getCurrentLocale] }} </a>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import moment from 'moment';
    import VueScrollTo from 'vue-scrollto';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // ----------------------------------
                searchboxheadlineflights: {
                    en: 'Search and book flights',
                    de: 'Flüge suchen und buchen',
                },
                searchboxheadlineservices: {
                    en: 'Find flights and add seats',
                    de: 'Flüge finden und Sitzplätze hinzubuchen',
                },
                searchboxheadlineflights2: {
                    en: 'Have a good trip with Schauinsland!',
                    de: 'Schauinsland wünscht Ihnen gute Reise!',
                },
                // ----------------------------------
                outwardandreturnflight: {
                    en: 'Round Trip',
                    de: 'Hin- und Rückflug',
                },
                outwardonlyflight: {
                    en: 'One way only',
                    de: 'nur Hinflug',
                },
                // ----------------------------------
                where: {
                    en: 'Where',
                    de: 'Wohin',
                },
                yourplaceofdeparture: {
                    en: 'YOUR DEPARTURE',
                    de: 'IHR ABFLUGSORT',
                },
                yourplaceofdestination: {
                    en: 'YOUR DESTINATION',
                    de: 'IHR ZIELORT',
                },
                departureairport: {
                    en: 'Please choose your departure airport',
                    de: 'Wählen Sie Ihren Startflughafen',
                },
                destinationairport: {
                    en: 'Please choose your destination airport',
                    de: 'Wählen Sie Ihren Zielflughafen',
                },
                // ----------------------------------
                when: {
                    en: 'When',
                    de: 'Wann',
                },
                departuredate: {
                    en: 'Date Departure',
                    de: 'Abflugdatum',
                },
                returndate: {
                    en: 'Date Return',
                    de: 'Rückflugdatum',
                },
                // ----------------------------------
                who: {
                    en: 'Who',
                    de: 'Wer',
                },
                adult: {
                    en: 'Adults',
                    de: 'Erwachsene',
                },
                adultyears: {
                    en: '(From 12+ Years)',
                    de: '(Ab 12+ Jahre)',
                },
                child: {
                    en: 'Children',
                    de: 'Kinder',
                },
                childyears: {
                    en: '(2 to 12 Years)',
                    de: '(2 bis 12 Jahre)',
                },
                infant: {
                    en: 'Infants',
                    de: 'Kleinkinder',
                },
                infantyears: {
                    en: '(Up to 2 Years)',
                    de: '(Bis 2 Jahre)',
                },
                // ----------------------------------
                findflights: {
                    en: 'FIND FLIGHTS',
                    de: 'FLÜGE FINDEN',
                },
                tomanypeople: {
                    en: 'Please use our group booking form for flight bookings of 11 or more passengers or contact customer service..',
                    de: 'Bitte nutzen Sie bei einer Flugbuchung ab 11 Passagiere unser Gruppenbuchungsformular oder wenden Sie sich an den Kundenservice..',
                },
                // currentLocale: 'de',
                // >>> ---------------------------------------------------------
                // >>> ---------------------------------------------------------
                airportsOrigins: [],
                airportsDestinations: [],
                departuresLoaded: false,
                destinationsLoaded: false, // Des Aiports loaded?
                // >>> ---------------------------------------------------------
                // >>> --------------------------------------------------------- SearchForm
                desArprtCode: '', // model, new select Field
                depArprtCode: '',  // model, new sselect Field

                outwardonly: false, // ReturnFlight too?
                today: moment().add(1, 'days').format('DD.MM.YYYY'),
                tommorow: moment().add(2, 'days').format('DD.MM.YYYY'),
                listOfPaxes: { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8' },
                // noADT: 1,
                // noCHD: '0',
                // noINF: '0'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Do '/origines' Call.
        * Note:
        *
        */
        created: function() {

            var me = this;


            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> created');
            this.call_listAirportsOrigines();

        }, // eo function created()

        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note:
        *
        */
        mounted: function() {

            var me = this;


            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> mounted');
            this.$refs.noADT.value = 1; // @startup
            me.$selectInits(this.modulo, this.getCurrentLocale);

        },  // eo function mounted()

        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            var me = this;


            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> updated');
            me.$selectInits(this.modulo, this.getCurrentLocale);

        },  // eo function updated()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagSharedShowFlightSearchResults', // Control Flag
                'actn_FlagServicesShowBookingnoSearchResults', // Control Flag
                'actn_setBookingAirports', // Part 1
                'actn_setBookingUsersSearchData', // Part 2
                'actn_setBookingFlightSearchResults', // set: SearchResults
                'actn_FlagBookingOutwardFlightSelected', // set: 'Outward Flight selected
                'actn_FlagBookingReturnFlightSelected', // set: 'Return Flight selected
                'actn_setBookingFlightIdSelectedOutward', // set: 'Out Selected Flight Id'
                'actn_setBookingFlightIdSelectedReturn', // set: 'Ret Selected Flight Id'
                'actn_set_areWeInServicesBookingNoMode', // set:
            ]),


            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/origines'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Origines ('listAirports').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listAirportsOrigines: function() {

                var me = this,
                    hdrs = '',
                    url = '';


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsOrigines');
                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/origines/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/origines'
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsOrigins = response.data.originesRS.dep;
                                me.airportsOrigins.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.departuresLoaded = true;
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsOrigines()


            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/destinations/ZRH'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Destinations ('listAirports').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listAirportsDestinations: function(event) {

                var me = this,
                    hdrs = '',
                    url = '';


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsDestinations');
                this.desArprtCode = ''; // reset model
                this.onChange_FlightsSearchForm(); // reset


                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/destinations/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/destinations/';
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url + event.i)
                    .then(function(response) {  // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsDestinations = response.data.destinationsRS.des;
                                me.airportsDestinations.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.destinationsLoaded = true;
                                break;
                            default: // 'ERROR'
                                // me.$toc('I am in Header Error');
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsDestinations()

            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/listflights'
            * Call::'/registration/flights'
            *
            * Desc: Getting Flights ('listflights').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listFlights: function(params) {

                var me = this,
                    hdrs = '',
                    options = {},
                    url = '';


                me.$toc('>>> booking/flightsearch/FlighSearchTab.vue >>> call_listFlights');
                this.onChange_FlightsSearchForm(); // reset
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/listflights/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/flights/';
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put(url, params)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.actn_setBookingFlightSearchResults(response.data.listFlightsRS.flts);
                                me.actn_FlagSharedShowFlightSearchResults(true); // Show 'Section'
                                setTimeout(function() {
                                    me.$scrollTo('#contentElement', 200, options);
                                }, 300);
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listFlights()



            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: SearchForm gets submitted.
            * Note:
            *
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    depAfter = '',
                    myDepPickerDate,
                    theActualTime,
                    isToday,
                    date_to,
                    date_from;


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onSubmit');
                // >>> 0. Empty Airports ---------------------------------------
                if (this.depArprtCode === null || this.desArprtCode === null || this.depArprtCode === '' || this.desArprtCode === '') {
                    return;
                }

                // >>> 0a. To many Pax -----------------------------------------
                if (+this.$refs.noADT.value + +this.$refs.noCHD.value + +this.$refs.noINF.value > 10) {
                    me.$toasted.global.sdr_app_error({
                        message : this.tomanypeople[this.getCurrentLocale]
                    });
                    return;
                }


                // >>> 1. Check for Today&depAfter-Time ------------------------
                date_from = submitEvent.target.elements.date_from.value.split('.');
                myDepPickerDate = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');

                theActualTime = moment().format('HH:mm:ss');

                isToday = moment(String(myDepPickerDate)).isSame(moment().format('YYYY-MM-DD'));

                if (isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
                }
                if (!isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
                }


                // >>> 2. Builds Object ----------------------------------------
                const requestParamObject = {
                    depArprtCode: this.depArprtCode.i, // submitEvent.target.elements.depArprtCode.value,
                    desArprtCode: this.desArprtCode.i, // submitEvent.target.elements.desArprtCode.value,
                    noADT: this.$refs.noADT.value, // this.noADT,
                    noCHD: this.$refs.noCHD.value, // this.noCHD,
                    noINF: this.$refs.noINF.value, // this.noINF,
                    ojArprtCode: '', // not clear
                    ojType: '', // not clear
                    depAfter: depAfter,
                    rTrip: false,
                    limit: 5,
                };


                // >>> 3. Oneway || Roundtrip ? --------------------------------
                if (this.outwardonly === false) {
                    date_to = submitEvent.target.elements.date_to.value.split('.');
                    requestParamObject.retAfter = moment(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDTHH:mm:ss+0000');
                    requestParamObject.rTrip = true;
                }


                if (requestParamObject.depArprtCode !== '' && requestParamObject.desArprtCode !== '') {
                    me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
                    me.actn_FlagServicesShowBookingnoSearchResults(false); // Hide 'Section'

                    this.actn_setBookingAirports({ // remember in state
                        depArprtCode: requestParamObject.depArprtCode,
                        depArprtName: this.depArprtCode.l, // submitEvent.target.elements.depArprtCode.options[submitEvent.target.elements.depArprtCode.selectedIndex].text,
                        desArprtCode: requestParamObject.desArprtCode,
                        desArprtName: this.desArprtCode.l // submitEvent.target.elements.desArprtCode.options[submitEvent.target.elements.desArprtCode.selectedIndex].text,
                    });
                    this.actn_setBookingUsersSearchData(requestParamObject);    // remember in state

                    this.actn_set_areWeInServicesBookingNoMode(false);          // we are NOT in bookingno mode

                    this.call_listFlights(requestParamObject);
                }

            }, // eo function onSubmit()


            /*******************************************************************
            * onChange_FlightsSearchForm()
            *
            * Desc:
            * Note: Kind of Reset here.
            *
            */
            onChange_FlightsSearchForm: function() {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onChange_FlightsSearchForm');
                me.actn_setBookingFlightSearchResults({});
                me.actn_FlagSharedShowFlightSearchResults(false); // set: 'Hide Section'
                me.actn_FlagBookingOutwardFlightSelected(false); // set: 'No Outward selected'
                me.actn_FlagBookingReturnFlightSelected(false); // set: 'No Return selected'
                me.actn_setBookingFlightIdSelectedOutward(null); // set: selected flight id out -> null
                me.actn_setBookingFlightIdSelectedReturn(null); // set: selected flight id ret -> null

                eventBus.$emit('needtorerender');

            }, // eo function onChange_FlightsSearchForm()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style>
    .search-box-wrapper.style1 .search-tab-content .title-container {
        background: #AB3B7A;
    }
    .search-box-wrapper.style1 .search-tab-content .title-container-srvcs {
        background: #0082c8;
    }

    .checkbox.checked:before, .radio.checked:before {
        border-color: #AB3B7A;
        color: #fff;
        background: #AB3B7A;
        content: "\e8ba";
    }
    .radiosrvcs.checked:before {
        border-color: #0082c8;
        color: #fff;
        background: #0082c8;
        content: "\e8ba";
    }

    .icon-check-srvcs {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-srvcs:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #0082c8;
    }




    /* booking */
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        background: #ab3b7a;
        color: #ffffff;
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        fill: #ffffff;
    }

    .vs__dropdown-toggle, .vs--disabled .vs__open-indicator, .vs--disabled .vs__search, .vs--disabled .vs__selected {
        background-color: #ab3b7a;
    }



    .vs__selected {
        color: rgb(255, 255, 255);
        font-size: 14px;
    }
    .vs__select {
        color: rgb(255, 255, 255);
        font-size: 14px;
    }

    .vs__search, .vs__search:focus {
        line-height: 2.7;
    }

    .vs__dropdown-option {
        color: rgb(255, 255, 255);
    }
    .vs__dropdown-option--highlight {
        background: #5897fb;
        color: #fff;
        font-size: 14px;
    }




    /* services */
    .style-chooser-srvcs .vs__search::placeholder,
    .style-chooser-srvcs .vs__dropdown-toggle,
    .style-chooser-srvcs .vs__dropdown-menu {
        background: #0082c8;
        color: #ffffff;
    }

    .style-chooser-srvcs .vs__clear,
    .style-chooser-srvcs .vs__open-indicator {
        fill: #ffffff;
    }

    .style-chooser-srvcs .vs__dropdown-toggle,
    .style-chooser-srvcs .vs--disabled .vs__open-indicator,
    .style-chooser-srvcs.vs--disabled .vs__search,
    .style-chooser-srvcs .vs--disabled .vs__selected {
        background-color: #0082c8;
    }




    /* booking && services */
    .vs--disabled .vs__open-indicator {
        /* background-color: #0082c8; */
        opacity: 0;
    }





    /* EDGE - Input Field (Order: Booking, Services) */
    .style-chooser .vs--disabled .vs__clear,
    .style-chooser .vs--disabled .vs__dropdown-toggle,
    .style-chooser .vs--disabled .vs__open-indicator,
    .style-chooser .vs--disabled .vs__search,
    .style-chooser .vs--disabled .vs__selected {
        background-color: #ab3b7a;
        color: #fff;
    }


   .style-chooser-srvcs .vs--disabled {
        background-color: #0082c8 !important;
        color: #fff;
    }




     /* .style-chooser-srvcs .vs--disabled .vs__clear {
        background-color: #0082c8;
        color: #fff;
    } */

    /* .style-chooser-srvcs .vs--disabled .vs__dropdown-toggle {
        background-color: #0082c8;
        color: #fff;
    } */
    /* .style-chooser-srvcs .vs--disabled .vs__open-indicator {
        background-color: #0082c8;
        color: #fff;
    } */
    /* .style-chooser-srvcs .vs--disabled .vs__search {
        background-color: #0082c8;
        color: #fff;
    } */
    /* .style-chooser-srvcs .vs--disabled .vs__selected {
        background-color: #0082c8;
        color: #fff;
    } */




    /* EDGE - Menue, Background (Order: Booking, Services) */
    .vs__dropdown-menu {
        background: #ab3b7a;
        color: #ffffff;
    }
    .style-chooser-srvcs .vs__dropdown-menu {
        background: #0082c8;
        color: #ffffff;
    }

    /* EDGE - Schriftfarbe (Booking, Servies) */
    .vs--disabled .vs__open-indicator,
    .vs--disabled .vs__search,
    .vs--disabled .vs__selected,
    .vs__dropdown-toggle{
        color: #fff;
    }




    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .search-box-wrapper.style1 .search-tab-content .search-content {
            padding: 18px 25px 25px;
            padding-top: 18px;
            padding-right: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
        }
    }

</style>
